  $(function(){
    $.iconPremiumTimer = function(options) {
        var methods = {
            addPremium: function(type_id, time_end,premium,p_id) {
                time_end = intval(time_end);
                p_id=intval(p_id);
                data.timer[type_id] = {time_end: time_end, old: 0,premium:premium,type_id:type_id,p_id:p_id};
                updatePremium();
            },
            deletePremium: function(type_id) {
                if (typeof data.timer[type_id] != "undefined") {
                    delete data.timer[type_id];
                }
                updatePremium();
            },
            open: function() {
                
                if(typeof data.best_key!="undefined" && data.best_key){
                    if(data.timer[data.best_key].old==0){
                        data.timer[data.best_key].old=1;
                        main.data("premiumData", data);
                        var best= data.timer[data.best_key];
                        $.goToLocation("premiumone/"+best.type_id+"/" + best.p_id + "/1/");
                    }
                }
            }
        };
        function updatePremium() {
            var  cur = $.getCurrentTime(),i, bum, best={}, del_arr = [];
            for (i in data.timer) {
                bum=data.timer[i];
                if(bum.time_end==0 || bum.time_end>cur){
                    if(typeof best.type_id=="undefined"){
                        best=copyObj(bum);
                    }
                    if(best.time_end==0){
                        if(best.premium>bum.premium){
                            best=copyObj(bum);
                        }
                    }
                    else if(bum.time_end>0 && bum.time_end<best.time_end){
                        best=copyObj(bum);
                    }  
                }
                else {
                    del_arr.push(i);
                }
            }
            
            for (i in del_arr) {
                delete data.timer[del_arr[i]];
            }
            
            if(typeof best.type_id!="undefined"){
                main.removeClass("hide");
                if(best.time_end>0){
                     _timerManager.addTimer("#ic_premium_timer",best.time_end,0);
                     timer.removeClass("hide");
                }
                else{
                    timer.addClass("hide");
                }
                if(Object.keys(data.timer).length == 1){
                    main.attr({"action": "premiumone/"+best.type_id+"/" + best.p_id + "/1/"});
                }
                else{
                    main.attr({"action": "premium"});
                }
                data.best_key=best.type_id;
            }
            else{
                main.addClass("hide");
                data.best_key=0;
            }
            

            main.data("premiumData", data);
            timer.off("timer_end").on("timer_end", function() {
                updatePremium();
            });
        }
        var arg = Array.prototype.slice.call(arguments, 1), main = $("#ic_premium"), data = main.data("premiumData"),
                timer = main.find("#ic_premium_timer");
        if (typeof data == "undefined") {
            data = {timer: {}};
        }
        if (methods[options]) {
            methods[options].apply(this, arg);
        }
    };
});